import React, { useEffect } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import { trackEvent } from 'helpers/analytics';
import LoadingFullPage from 'components/molecules/LoadingFullPage';
import { SignUp } from './steps/signUp';
import { useOnboarding } from './hooks/useOnboarding';
import { NetworkOnboardingLayout } from './components/networkOnboardingLayout';
import usePageHook from '../../hooks/usePageHook';

import Walkthrough from './walkthrough';

const ONBOARDING_START_TRACKED_KEY = 'admin_onboarding_start_tracked';

export const Onboarding = () => {
  const { activeNetwork, path, isLoadingCompanyNetwork, isLoadingMfaStatus, isMfaStatusError, params } =
    useOnboarding();
  usePageHook('Onboarding');

  useEffect(() => {
    if (activeNetwork?.id) {
      const trackedNetworkId = sessionStorage.getItem(ONBOARDING_START_TRACKED_KEY);
      if (trackedNetworkId !== String(activeNetwork.id)) {
        sessionStorage.setItem(ONBOARDING_START_TRACKED_KEY, String(activeNetwork.id));
        trackEvent('admin_onboarding:start', { collection_id: activeNetwork.id });
      }
    }
  }, [activeNetwork?.id]);

  // Fail closed: if the MFA-required status can't be loaded, block onboarding rather than
  // let the walkthrough skip the enrollment gate and complete without 2FA. (A 401 here is
  // transparently refreshed+retried by the axios interceptor, so this only blocks on a real
  // backend error.)
  if (isLoadingCompanyNetwork || isLoadingMfaStatus || isMfaStatusError) return <LoadingFullPage />;

  if (!activeNetwork) {
    return <Redirect to="/not-found" />;
  }

  return (
    <NetworkOnboardingLayout>
      <Route path={path} exact>
        <SignUp />
      </Route>
      <Switch>
        <Route path={`${path}/onboarding/:step`}>
          <Walkthrough />
        </Route>
        <Route path={`${path}/onboarding`}>
          <Redirect
            to={
              params.employerSlug
                ? `/networks/${activeNetwork.slug}/company/${params.employerSlug}/welcome`
                : `/networks/${activeNetwork.slug}/welcome`
            }
          />
        </Route>
      </Switch>
    </NetworkOnboardingLayout>
  );
};
